import { AnalyticsConnector } from '@amplitude/analytics-connector';
export var getAnalyticsConnector = function () {
    return AnalyticsConnector.getInstance('$default_instance');
};
//# sourceMappingURL=analytics-connector.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amplitude/analytics-client-common/lib/esm/analytics-connector.js
// module id = 90
// module chunks = 0